// @ts-check

import { base64Tool } from "./base64.js";
import { crossMultiplicationTool } from "./cross-multiplication.js";
import { mortgageRentalCalculatorTool } from "./mortgage-rental-calculator.js";
import { nanoidGeneratorTool } from "./nanoid-generator.js";
import { percentageCalculatorTool } from "./percentage-calculator.js";
import { randomNumberGeneratorTool } from "./random-number-generator.js";
import { shopMarginCalculatorTool } from "./shop-margin-calculator.js";
import { sortTool } from "./sort.js";
import { timestampTool } from "./timestamp.js";
import { timezonesTool } from "./timezones.js";
import { urlCodecTool } from "./url-codec.js";
import { wordCountTool } from "./word-count.js";
import { zwsTool } from "./zws.js";

/** @typedef {ReturnType<typeof import("lit-html").html>} LitView */
/** @typedef {Record<string, string | boolean | number>} ToolState */
/** @typedef {{
 *   scheduleRender: () => void,
 *   handleFieldInput: (record: ToolState, field: string, event: Event) => void,
 *   handleCheckboxInput: (record: ToolState, field: string, event: Event) => void,
 *   setTemporaryStatus: (record: ToolState, field: string, nextValue: string, resetValue: string, timerKey: string) => void,
 * }} ToolEnv */
export const TOOLS = [
  percentageCalculatorTool,
  crossMultiplicationTool,
  shopMarginCalculatorTool,
  mortgageRentalCalculatorTool,
  nanoidGeneratorTool,
  randomNumberGeneratorTool,
  timestampTool,
  timezonesTool,
  base64Tool,
  urlCodecTool,
  sortTool,
  wordCountTool,
  zwsTool,
];
